var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Vue as VueClass, Component, Prop, Watch } from 'vue-property-decorator';
import RelatedBusinessesModal from './RelatedBusinessesModal.vue';
import { connect } from '@/overmind';
import { getApiUrl } from '@/shared/utils/helpers';
let RelatedBusinessesButton = class RelatedBusinessesButton extends VueClass {
    constructor() {
        super(...arguments);
        this.isModalOpen = false;
        this.isLoading = false;
        this.relatedBusinesses = [];
        this.totalNewPhones = 0;
    }
    get activeSearchId() {
        return this.currentSearchId || this.defaultSearchId || 's';
    }
    async created() {
        await this.loadRelatedCompanies(this.cnpj);
    }
    async onCnpjChanged(newCnpj) {
        await this.loadRelatedCompanies(newCnpj);
    }
    async loadRelatedCompanies(cnpj) {
        if (!cnpj)
            return;
        const cleanCnpj = cnpj.replace(/\D/g, '');
        if (!cleanCnpj)
            return;
        this.isLoading = true;
        try {
            const baseApi = getApiUrl('v4');
            const response = await Vue.axios.get(`${baseApi}/companies/${cleanCnpj}/related_companies?skip_handle_error`);
            if (response && response.status === 200 && response.data) {
                this.relatedBusinesses = this.mapApiResponse(response.data.related_companies || []);
                this.totalNewPhones = response.data.total_new_phones || 0;
            }
        }
        catch {
            // silently ignore — button stays functional without data
        }
        finally {
            this.isLoading = false;
        }
    }
    mapApiResponse(companies) {
        return companies.map(c => ({
            name: c.company_name || '',
            cnpj: c.cnpj,
            relation: c.relation || '',
            website: c.website || null,
            emailsCount: c.new_emails_count || 0,
            phonesCount: c.new_phones_count || 0,
            decisorsCount: c.partners_count || 0,
            newPhonesCount: c.new_phones_count || 0,
            newEmailsCount: c.new_emails_count || 0,
            partnersCount: c.partners_count || 0,
            iconType: 'cnpj',
        }));
    }
    openModal() {
        this.isModalOpen = true;
        this.$emit('click');
    }
    async reloadForCnpj(cnpj) {
        await this.loadRelatedCompanies(cnpj);
    }
};
__decorate([
    Prop({ type: String, required: true })
], RelatedBusinessesButton.prototype, "cnpj", void 0);
__decorate([
    Prop({ type: String, default: 'Empresas Ligadas' })
], RelatedBusinessesButton.prototype, "label", void 0);
__decorate([
    Watch('cnpj')
], RelatedBusinessesButton.prototype, "onCnpjChanged", null);
RelatedBusinessesButton = __decorate([
    Component(connect(({ state }) => ({
        currentSearchId: state.search.currentSearchId,
        defaultSearchId: state.search.defaultSearch.id,
    }), {
        components: {
            RelatedBusinessesModal,
        },
    }))
], RelatedBusinessesButton);
export default RelatedBusinessesButton;
